import { AddGroupModal } from "./AddGroupModal";

export default AddGroupModal;
